import $ from 'jquery';
import { scrollToEl } from '../global/helpers';

const isi = {
	init() {
		this.trigger = document.querySelector('.isi-fixed');
		this.isiFull = document.getElementById('isi');

		if (this.trigger && this.isiFull) {
			this.scrollIntoView = this.scrollIntoView.bind(this);
			this.trigger.addEventListener('click', this.scrollIntoView);

			this.toggleTriggerVisibility = this.toggleTriggerVisibility.bind(this);
			window.addEventListener('resize', this.toggleTriggerVisibility);
			window.addEventListener('scroll', this.toggleTriggerVisibility);
			this.toggleTriggerVisibility();
		}
	},

	scrollIntoView() {
		scrollToEl($(this.isiFull));
	},

	toggleTriggerVisibility() {
		const rect = this.isiFull.getBoundingClientRect();
		if (rect.top < window.innerHeight) {
			this.trigger.classList.add('hide');
		} else {
			this.trigger.classList.remove('hide');
		}
	},
};

document.addEventListener('DOMContentLoaded', () => {
	isi.init();
});
